import React from 'react';
import { Table, Button } from '../common';
import OnPremPortOpeningRequest from '../../models/entities/PortOpeningRequestOnPrem';
import ProgressBarSmall from '../OnPremPortOpeningRequests/components/ProgressBarSmall';
import { useNavigate } from 'react-router-dom';
import './ApprovalsOnPremPORsTableRow.css';

interface ApprovalsOnPremPORsTableRowProps {
    onprempor: OnPremPortOpeningRequest;
}

const ApprovalsOnPremPORsTableRow = ({ onprempor }: ApprovalsOnPremPORsTableRowProps) => {
    const navigate = useNavigate();
	const handleViewDetails = () => {
		navigate(`/onPremPortOpeningRequests/${onprempor.id}`);
	};
    
    return (
        <Table.Row key={onprempor.id} verticalAlign='middle'>
            <Table.Cell>
                #{onprempor.id}
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center'>
                {onprempor.direction.name}
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center center-align'>
                <ProgressBarSmall 
                    workflowState={onprempor.workflowInstance?.currentWorkflowInstanceState?.workflowState} 
                    porScope={onprempor.direction?.name} 
                />
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center'>
                <Button size='medium' onClick={handleViewDetails} variant="primary">
                    See Details
                </Button>
            </Table.Cell>
        </Table.Row>
    );
}

export default ApprovalsOnPremPORsTableRow;